export enum E_RouterNames {
    adminAlarmCenter = 'adminAlarmCenter',
    adminMonitorAlarm = 'adminMonitorAlarm',
    adminSensorAlarm = 'adminSensorAlarm',
    adminAlarmTrend = 'adminAlarmTrend',
    adminAlarmSpectrum = 'adminAlarmSpectrum',
    login = 'login',
    /** 登录后的业务系统选择门户 */
    platformPortal = 'platformPortal',

    /**
     * 大屏入口
     */
    largeScreenNormal = 'largeScreenNormal',
    largeScreen = 'largeScreen',

    /**
     * 总公司大屏
     */
    largeScreenCompany = 'largeScreenCompany',

    /**
     * 新版大屏
     */
    largeScreen2 = 'largeScreen2',

    /**
     * 遗留大屏
     */
    largeScreenLegacyNormal = 'largeScreenLegacyNormal',
    largeScreenLegacyExt = 'largeScreenLegacyExt',

    /**
     * 启停阈值管理
     */
    equipmentRunThreshold = 'equipmentRunThreshold',
    /**
     * 启停阈值详情
     */
    equipmentRunThresholdDetail = 'equipmentRunThresholdDetail',

    largeScreenAdmin = 'largeScreenAdmin',
    customerManagement_tenant = 'customerManagement_tenant',
    /**
     * 客户管理 - 数据稀释
     */
    dataDilution = 'dataDilution',
    /**
     * OpenAPI管理
     */
    openAPI = 'openAPI',

    /**
     * AI诊断
     */
    aiAlarmReport = 'aiAlarmReport',

    /**
     * 模型诊断
     */
    faultAnalysisDefault = 'faultAnalysisDefault',

    /**
     * 模型诊断2
     */
    modelAlarmReport = 'modelAlarmReport',

    /**
     * 模型诊断2 详情
     */
    modelAlarmReportDetail = 'modelAlarmReportDetail',

    /**
     * 故障案例
     */
    FaultCaseLibrary = 'FaultCaseLibrary',
    FaultCaseLibraryCreateEdit = 'FaultCaseLibraryCreateEdit',
    FaultRepair = 'FaultRepair',
    FaultUpkeep = 'FaultUpkeep',
    FaultPlatformHandleResults = 'FaultPlatformHandleResults',

    /**
     * 健康检测
     */
    healthTesting = 'healthTesting',
    healthTestingEquipmentList = 'healthTestingEquipmentList',
    healthTestingMappingDetail = 'healthTestingMappingDetail',
    healthTestingTrainList = 'healthTestingTrainList',

    /**
     * 实时数据
     */
    realtimeData = 'realtimeData',

    /**
     * 历史数据
     */
    historyData = 'historyData',
    historyPoint = 'historyPoint',
    /**
     * 故障标签
     */
    faultTagLibrary = 'faultTagLibrary',

    /**
     * 诊断周报
     */
    weeklyReport = 'weeklyReport',

    weeklyReportCreateAndEdit = 'weeklyReportCreateAndEdit',

    /**
     * 新版诊断周报
     */
    weeklyReportCreateAndEdit2 = 'weeklyReportCreateAndEdit2',

    // /**
    //  * RVT50周报
    //  */
    // RVT50weeklyReport = 'RVT50weeklyReport',

    /**
     * 在线监测
     */
    onlineMonitor = 'onlineMonitor',
    onlineMonitorDefault = 'onlineMonitorDefault',
    onlineMonitorOld = 'onlineMonitorOld',
    onlineDeviceOld = 'onlineDeviceOld',
    voicePrintRecord = 'voicePrintRecord',
    area_Points = 'area_Points',
    equipment_Points = 'equipment_Points',
    /**
     * 数据查询
     */
    dataSearch = 'dataSearch',
    configureManagement = 'configureManagement',

    /**
     * 温度补偿
     */
    temperatureCompensation = 'temperatureCompensation',

    /**
     * 故障诊断
     */
    faultAnalysis = 'faultAnalysis',

    /**
     * 故障诊断详情
     */
    faultAnalysisEquipment = 'faultAnalysisEquipment',

    /**
     * 图谱分析
     */
    waveSpectrum = 'waveSpectrum',

    /**
     * 报警记录
     */
    alarmReport = 'alarmReport',

    /**
     * 报警记录-详情
     */
    alarmReportDetail = 'alarmReportDetail',

    /**
     * 测点管理(New)
     */
    sensorManagementNew = 'sensorManagementNew',


    /**
     * 点检任务
     */
    inspectionTask = 'inspectionTask',
    inspectionTaskAddEdit = 'inspectionTaskAddEdit',
    /**
     * 点检班组
     */
    inspectionGroup = 'inspectionGroup',
    /**
     * 点检班组(创建)
     */
    inspectionGroupAddEdit = 'inspectionGroupAddEdit',
    /**
     * 巡检点管理
     */
    inspectionPoint = 'inspectionPoint',
    inspectionPointAddEdit = 'inspectionPointAddEdit',
    /**
     * 点检路线
     */
    inspectionLine = 'inspectionLine',
    inspectionLineAddEdit = 'inspectionLineAddEdit',
    /**
     * 点检标准
     */
    inspectionStandard = 'inspectionStandard',
    /**
     * 点检区域
     */
    inspectionArea = 'inspectionArea',
    inspectionAreaEdit = 'inspectionAreaEdit',
    /**
     * 隐患库
     */
    inspectionDangerLib = 'inspectionDangerLib',
    /**
     * 隐患库
     */
    inspectionDangerLibAddEdit = 'inspectionDangerLibAddEdit',
    /**
     * 隐患
     */
    inspectionDanger = 'inspectionDanger',
    /**
     * 隐患
     */
    inspectionDangerAddEdit = 'inspectionDangerAddEdit',
    /**
     * 保养库
     */
    inspectionUpkeepLib = 'inspectionUpkeepLib',
    inspectionUpkeepLibAddEdit = 'inspectionUpkeepLibAddEdit',
    /**
     * 保养
     */
    inspectionUpkeep = 'inspectionUpkeep',

    /**
     * 保养
     */
    inspectionUpkeepAddEdit = 'inspectionUpkeepAddEdit',

    /**
     * 维修库
     */
    inspectionRepairLib = 'inspectionRepairLib',
    inspectionRepairLibAddEdit = 'inspectionRepairLibAddEdit',
    /**
     * 维修
     */
    inspectionRepair = 'inspectionRepair',
    inspectionRepairAddEdit = 'inspectionRepairAddEdit',
    /**
     * 点检周报
     */
    inspectWeekReport = 'inspectWeekReport',
    inspectWeeklyReportCreateAndEdit = 'inspectWeeklyReportCreateAndEdit',

    /**
     * 点检测点
     */
    inspectionMapping = 'inspectionMapping',

    /**
     * 
     */
    inspectionTaskView = 'inspectionTaskView',


    /**
     * 设备总览
     */
    deviceScreen = 'deviceScreen',
    /**
     * 子公司管理
     */
    subCompanyManagement = 'subCompanyManagement',
    uploadImage_Company = 'uploadImage_Company',
    uploadImage_Area = 'uploadImage_Area',
    /**
     * 网关管理
     */
    gatewayManagement = 'gatewayManagement',
    /**
     * 网关详情
     */
    gatewayDetails = 'gatewayDetails',
    /**
     * 网关设置
     */
    gatewaySetting = 'gatewaySetting',
    /**
     * 模型管理
     */
    modelManagement = 'modelManagement',
    /**
     * 设备管理
     */
    equipmentManagement = 'equipmentManagement',
    uploadImage_Equipment = 'uploadImage_Equipment',
    equipmentComponentManagement = 'equipmentComponentManagement',
    /**
     * 设备日志
     */
    deviceLog = 'deviceLog',
    /**
     * 传感器列表
     */
    sensorList = 'sensorList',
    sensorCreateEdit = 'sensorCreateEdit',
    sensorWave = 'sensorWave',
    sensorNewCreateEdit = 'sensorNewCreateEdit',
    /**
     * 轴承库管理
     */
    bearingManagement = 'bearingManagement',
    /**
     * 阈值管理
     */
    thresholdManagement = 'thresholdManagement',
    /**
     * 报警灯管理
     */
    alarmLampManagement = 'alarmLampManagement',
    alarmLampCreateEdit = 'alarmLampCreateEdit',
    /**
     * 阈值设定
     */
    sensorThresholdManagement = 'sensorThresholdManagement',

    /**
     * 气体阈值设定
     */
    gasThresholdManagement = "gasThresholdManagement",
    /**
     * 粉尘阈值设定
     */
    gdsThresholdManagement = "gdsThresholdManagement",

    /**
     * 数采器
     */
    collectCardManagement = 'collectCardManagement',
    collectCardCreateEdit = 'collectCardCreateEdit',

    /**
     * 用户管理
     */
    userList = 'userList',
    /**
     * 权限管理
     */
    authorityManagement = 'authorityManagement',
    /**
     * 角色管理
     */
    roleList = 'roleList',
    /**
     * 邮件模板
     */
    emailManagement = 'emailManagement',
    /**
     * 语音管理
     */
    voiceManagement = 'voiceManagement',
    /**
     * app版本升级
     */
    appver = 'appver',
    /**
     * app文章
     */
    appArticles = 'appArticles',
    appArticleAddEdit = 'appArticleAddEdit',
    /**
     * 轮播文章
     */
    appBanner = 'appBanner',
    /**
     * 公司简介
     */
    appBrief = 'appBrief',
    /**
     * 问答
     */
    ask = 'ask',
    /**
     * 菜单管理
     */
    customerManagement_menu = 'customerManagement_menu',
    customerManagement_dictList = 'customerManagement_dictList',
    /**
     * APP菜单管理
     */
    customerManagement_appMenu = 'customerManagement_appMenu',
    /**
     * 系统管理 - 操作日志
     */
    customerManagement_operateLog = 'customerManagement_operateLog',
    /**
     * 系统管理 - 登录日志
     */
    customerManagement_loginLog = 'customerManagement_loginLog',

    /**
     * 系统管理 - 日志管理
     */
    customerManagement_log = 'customerManagement_log',

    /**
     * Deepseek设置
     */
    deepseekSetting = 'deepseekSetting',
    /**
     * 大屏价值指标设置
     */
    platformScreenSetting = 'platformScreenSetting',
    /**
     * 更新推送
     */
    systemNoticeList = 'systemNoticeList',
    /**
     * 版本升级
     */
    firmwareUpgrad = 'firmwareUpgrad',
    firmwareUpgradList = 'firmwareUpgradList',
    /**
     * 故障案例库
     */
    faultCaseLibraryList_root = 'faultCaseLibraryList_root',

    /**
     * 诊断模型
     */
    diagnosticModel = 'diagnosticModel',
    /**
     * 诊断结论
     */
    diagnosticResult = 'diagnosticResult',

    /**
     * 新建更新
     */
    systemNoticeCreate = 'systemNoticeCreate',

    /**
     * 
     */
    faultCaseLibraryCreateEdit_root = 'faultCaseLibraryCreateEdit_root',

    /**
     * APP版本更新
     */
    appverCreate = 'appverCreate',

    /**
     * 分配角色
     */
    authRole = 'authRole',

    /**
     * 分配权限
     */
    authAuthority = 'authAuthority',

    /**
     * 用户管理-邮件模板 创建、编辑
     */
    emailCreateEdit = 'emailCreateEdit',

    aiAlarmReportDetail = 'aiAlarmReportDetail',

    /**
     * 故障诊断-详情
     */
    faultAnalysisDetail = 'faultAnalysisDetail',

    roleUser = 'roleUser',

    onlineDevice = 'onlineDevice',

    onlinePoint = 'onlinePoint',

    waveRecord = 'waveRecord',


    /**
     * 报警中心
     */
    alarmCenter = 'alarmCenter',
    /**
     * 温振报警
     */
    TempVibAlarm = 'TempVibAlarm',
    /**
     * 温振报警(历史)
     */
    TempVibAlarmHistory = 'TempVibAlarmHistory',

    /**
     * 气体报警
     */
    gasAlarm = 'gasAlarm',
    /**
     * 气体报警(历史)
     */
    gasAlarmHistory = 'gasAlarmHistory',

    /**
     * 粉尘报警
     */
    gdsAlarm = 'gdsAlarm',
    /**
     * 粉尘报警(历史)
     */
    gdsAlarmHistory = 'gdsAlarmHistory',


    /**
     * 电压报警
     */
    BatteryAlarm = 'BatteryAlarm',
    /**
     * 电压报警(历史)
     */
    BatteryAlarmHistory = 'BatteryAlarmHistory',

    /**
     * 终端移位
     *
     * */
    AngleAlarm = 'AngleAlarm',

    /**
     * 终端移位(历史)
     *
     * */
    AngleAlarmHistory = 'AngleAlarmHistory',

    /**
     * 离线
     */
    OfflineAlarm = 'OfflineAlarm',
    /**
     * 离线(历史)
     */
    OfflineAlarmHistory = 'OfflineAlarmHistory',

    /**
     * 邮件推送
     */
    MailPush = 'MailPush',

    /**
     * 微信推送
     */
    WechatPush = 'WechatPush',

    /**
     * 语音推送
     */
    VoicePush = 'VoicePush',


    /**
     * 巡检任务计划 
     */
    inspectionTaskPlan='inspectionTaskPlan',
    /**
     * 巡检任务计划Wave 
     */
    inspectionTaskPlanWave='inspectionTaskPlanWave',
    /**
     * 巡检任务计划 创建/编辑
     */
    inspectionTaskPlanAddEdit='inspectionTaskPlanAddEdit',

    /**
     * 点检报警
     */
    inspectionAlarm = 'inspectionAlarm',
    /**
     * 点检波形
     */
    inspectionWave = 'inspectionWave',
    /**
     * 点检趋势
     */
    inspectionTrend = 'inspectionTrend',

    /**
     * 即时点检
     */
    instantInspection = 'instantInspection',


    __click = '__click'
}
